// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLiveChatSettings } from "@rugby/App/Store/Selectors/GeneralSettings";
import { FC, useEffect } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
})

const LiveChat: FC<any> = ({session}) => {
    const { enableLiveChat, liveChatUrl } = useAppSelector(state => getLiveChatSettings(state));

    useEffect(() => {
        if (typeof window === "undefined" || typeof document === "undefined") {
            return;
        }

        if (!enableLiveChat || !liveChatUrl) {
            return;
        }

        (window as any).acquire = (window as any).acquire || [];
        (window as any).acquire.push(function (app: any) {
            const setUIConfigFn = function () {
                if (app) {
                    app.ui.setVerticalMargin(100);
                    app.ui.setHorizontalMargin(-20);
                }
            };
            app.on("ui_reloaded", (socket: any, cr: any, sr: any) => {
                setUIConfigFn();
            });

            setUIConfigFn();
        });

        const {
            userLabel,
            email,
            language: { languageCode },
            properties: { defaultWarehouse, userInfo }
        } = session;
        
        if (session.isAuthenticated && userInfo) {
            const {
                phone,
                company,
            } = JSON.parse(userInfo);

            (window as any).acquire.push({
                userDetails: {
                    name: userLabel,
                    email,
                    phone,
                    remarks: company,
                    fields: {
                        branch: JSON.parse(defaultWarehouse).name,
                    }
                },
                lang: languageCode,
            })
        }


        const doc = document.createElement("script");
        doc.src = liveChatUrl;
        doc.async = true;
        const script: any = document.getElementsByTagName("script")[0];
        script.parentNode.insertBefore(doc, script);
    }, []);

    return null;
};

export default connect(mapStateToProps)(LiveChat);
